import { Observable } from 'rxjs';
import { tap, map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { SpinnerService } from './../../services/spinner/spinner.service';
import { HttpInterceptor, HttpHandler, HttpRequest, HttpEvent, HttpResponse } from '@angular/common/http';
import {
  Event,
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router
} from '@angular/router';
import {silentServices} from './../../config/config/config.constants';

@Injectable()
export class CVSHttpInterceptor implements HttpInterceptor {
  /**
   * Keeps track of active xhr and js bundle calls
   */
  private activeRequests = 0;
  private silent = silentServices;
  constructor(private spinner: SpinnerService, private router: Router) {
    /**
     * show spinner while redirection
     */
    this.router.events.subscribe((event: Event) => {
      switch (true) {
        case event instanceof NavigationStart: {
          this.spinner.show();
          break;
        }

        case event instanceof NavigationEnd:
        case event instanceof NavigationCancel:
        case event instanceof NavigationError: {
          if (this.activeRequests <= 0) {
            this.spinner.hide();
          }
          break;
        }
        default: {
          break;
        }
      }
    });
  }

  /**
   * param: {req<HttpRequest<any>>}
   * param: {next<HttpHandler>}
   *
   * return: {Observable<HttpEvent<any>>}
   */
  public intercept(req: HttpRequest<any>,
    next: HttpHandler): Observable<HttpEvent<any>> {
      if (req && !this.silent.some(s => req.url.indexOf(s) > -1)) {
        this.show();
      }
      return next.handle(req).pipe(
        tap(evt => {
          if (evt instanceof HttpResponse) {
            this.hide(req);
          }
        },
        (err) => {
          this.hide(req);
        },
        () => { })
      );

  }

  /**
   * @return: void
   * @description: hides the spinner
   * service request are completed.
   */
  private hide(req?): void {
    if (req && this.silent.some(s => req.url.indexOf(s) > -1)) {
      return;
    }
    this.activeRequests--;
    if (this.activeRequests <= 0) {
      this.spinner.hide();
    }
  }

  /**
   * @return: void
   * @description: triggers the spinner
   * display as service requests are received.
   */
  private show(): void {
    this.activeRequests++;

    if (this.activeRequests === 1) {
      this.spinner.show();
    }
  }
}
